var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4905 0C4.2465 0 0 4.256 0 9.5C0 14.744 4.2465 19 9.4905 19C14.744 19 19 14.744 19 9.5C19 4.256 14.744 0 9.4905 0ZM9.5 17.1C5.301 17.1 1.9 13.699 1.9 9.5C1.9 5.301 5.301 1.9 9.5 1.9C13.699 1.9 17.1 5.301 17.1 9.5C17.1 13.699 13.699 17.1 9.5 17.1ZM8.55 4.75H9.975V9.7375L14.25 12.274L13.5375 13.4425L8.55 10.45V4.75Z",
    fill: "#6BBBAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenPending);
export default __webpack_public_path__ + "static/media/greenPending.cc129d50ff515ea391d1c00d21e13880.svg";
export { ForwardRef as ReactComponent };